<template>
    <div component="TooltipQuestion">
        <div class="inner" :class="{ show: show }">{{ text }}</div>
        <div class="icon" @mouseover="show = true" @mouseleave="show = false">{{ icon }}</div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'TooltipQuestion',

    props: {
        text: {
            type: String,
            required: true,
        },

        icon: {
            type: String,
            default: 'help',
        },
    },

    data() {
        return {
            show: false,
        };
    },

    methods: {
        ...mapActions([]),
        ...mapMutations([]),
    },

    computed: {
        ...mapGetters([]),
    },

    components: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='TooltipQuestion'] {
    position: relative;
    width: 20px;
    height: 20px;

    .icon {
        font-size: 20px;
        color: @primary;

        &:hover {
            color: @secondary;
            //opacity: 0.5;
            transition: 0.3s;
        }
    }

    .inner {
        position: absolute;
        bottom: 35px;
        left: -20px;
        opacity: 0;
        transition: 0.3s;
        width: 190px;
        padding: 10px;
        .radius;
        background: white;
        box-shadow: 0 10px 25px 2px rgba(0, 0, 0, 0.3);
        pointer-events: none;
        z-index: 4;
        line-height: 1.2;

        &.show {
            opacity: 1;
        }

        &:before {
            position: absolute;
            bottom: -10px;
            left: 20px;
            content: '';
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 15px 10px 0 10px;
            border-color: white transparent transparent transparent;
        }
    }
}
</style>
